(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"), require("lodash"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "reactDOM", "lodash"], factory);
	else if(typeof exports === 'object')
		exports["ricosviewerEditorMode"] = factory(require("react"), require("react-dom"), require("lodash"));
	else
		root["ricosviewerEditorMode"] = factory(root["React"], root["ReactDOM"], root["_"]);
})((typeof self !== 'undefined' ? self : this), (__WEBPACK_EXTERNAL_MODULE__1112__, __WEBPACK_EXTERNAL_MODULE__8528__, __WEBPACK_EXTERNAL_MODULE__6056__) => {
return 